export var HEADER_NAVIGATION_SELECTOR_CLASS_PREFIX = 'HeaderNavigationSelector';
export var headerNavigationSelectorRoot = 'HeaderNavigationSelectorRoot';